<div>
  @if (ordersLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (ordersError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div>
      <div class="overflow-x-auto">
        <table
          mat-table
          [dataSource]="dataSource"
          [matSortActive]="currentSort.active"
          [matSortDirection]="currentSort.direction"
          matSort
          (matSortChange)="sortData($event)"
          class="w-full"
        >
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
                [aria-label]="checkboxLabel(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- Job # Column -->
          <ng-container matColumnDef="orderId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Job #
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.orderId }}
            </td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Description
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.description }}
            </td>
          </ng-container>

          <!-- Client PO # Column -->
          <ng-container matColumnDef="clientPurchaseOrder">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Client PO #
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.clientPurchaseOrder }}
            </td>
          </ng-container>

          <!-- CA # Column -->
          <ng-container matColumnDef="caNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              CA #
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.caNumber?.caNumber }}
            </td>
          </ng-container>

          <!-- Due Date Column -->
          <ng-container matColumnDef="promisedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Due Date
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.dueDate | date: CONFIG.date.dueDateFormat }}
            </td>
          </ng-container>

          <!-- Created Column -->
          <ng-container matColumnDef="dateCreated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Created
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.dateCreated | date: CONFIG.date.createdDateFormat }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Status
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.status }}
            </td>
          </ng-container>

          <!-- Client Column -->
          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Client
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.client.code }}
            </td>
          </ng-container>

          <!-- Assignee Column -->
          <ng-container matColumnDef="assignee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Assignee
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{
                order.assignee ? order.assignee.firstName + ' ' + order.assignee.lastName : 'N/A'
              }}
            </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="totalQuantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Quantity
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.totalQuantity }}
            </td>
          </ng-container>

          <!-- Total Price Column -->
          <ng-container matColumnDef="orderTotalPrice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Total Price
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.orderTotalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
            </td>
          </ng-container>

          <!-- Total Price Not Shipped Column -->
          <ng-container matColumnDef="orderTotalPriceNotShipped">
            <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-left">
              Total Price Not Shipped
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.orderTotalPriceNotShipped | currency: 'USD' : 'symbol' : '1.0-2' }}
            </td>
          </ng-container>

          <!-- Last Edited Column -->
          <ng-container matColumnDef="dateUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
              Last edited
            </th>
            <td mat-cell *matCellDef="let order" class="border-b p-4">
              {{ order.dateUpdated | date: CONFIG.date.createdDateFormat }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24"></th>
            <td mat-cell *matCellDef="let order" class="border-b p-4 text-right">
              <div class="invisible group-hover:visible flex items-center justify-end gap-2">
                <button
                  mat-icon-button
                  matTooltip="Archive Order"
                  (click)="archiveOrder(order); $event.stopPropagation()"
                  class="text-gray-700"
                  [ngClass]="{ '!text-red-500': order.isPastDue }"
                >
                  <mat-icon>archive</mat-icon>
                </button>
                <button
                  mat-icon-button
                  matTooltip="Edit Order"
                  [routerLink]="['/orders', order.id, 'edit']"
                  (click)="$event.stopPropagation()"
                  class="text-gray-700"
                  [ngClass]="{ '!text-red-500': order.isPastDue }"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ '!text-red-500': row.isPastDue }"
            [routerLink]="['/orders', row.id, 'view']"
            class="hover:bg-gray-100 cursor-pointer order-row group"
          ></tr>
        </table>
        <div
          *ngIf="!ordersLoading() && !ordersError() && dataSource.data.length === 0"
          class="text-center text-gray-500 py-8"
        >
          There are no records available.
        </div>
      </div>

      <ng-container *ngIf="dataSource.data.length !== 0">
        <ciwc-pagination
          [currentPage]="pageIndex"
          [pageSize]="pageSize"
          [totalItems]="totalOrders()"
          [pageSizeOptions]="pageSizeOptions"
          (pageChange)="handlePageEvent($event)"
        ></ciwc-pagination>

        <!-- Hidden paginator for functionality -->
        <div class="hidden">
          <mat-paginator
            #paginator
            [length]="totalOrders()"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="handlePageEvent($event)"
            aria-label="Select page"
          >
          </mat-paginator>
        </div>
      </ng-container>
    </div>

    <div class="flex justify-between">
      <div>
        <ng-container *ngIf="hasSelection">
          <button
            mat-flat-button
            color="primary"
            (click)="exportOrdersBundle()"
            [disabled]="exportOrdersBundleLoading()"
            class="mr-4 !bg-green-600 !hover:bg-green-700 !text-white font-semibold shadow-md flex items-center gap-2"
          >
            <ng-container *ngIf="!exportOrdersBundleLoading(); else loadingSpinner">
              Export Orders
            </ng-container>
            <ng-template #loadingSpinner>
              <div class="flex gap-2">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Exporting...</span>
              </div>
            </ng-template>
          </button>
        </ng-container>
      </div>
      <div *ngIf="exportOrdersBundleError()" class="text-red-600 ml-2 flex items-center">
        {{ exportOrdersBundleError() }}
      </div>

      <div *ciwcRoleAccess="['ROLE_SUPER_ADMIN']" class="flex flex-col items-end justify-center">
        <div class="text-lg" *ngIf="priceTotalNotShipped()">
          Orders Total Price Not Shipped :
          <span class="text-primary-700">{{
            priceTotalNotShipped() | currency: 'USD' : 'symbol' : '1.0-2'
          }}</span>
        </div>
        <div class="text-lg">
          Orders Total Price :
          <span class="text-primary-700">{{
            priceTotal() | currency: 'USD' : 'symbol' : '1.0-2'
          }}</span>
        </div>
      </div>
    </div>
  }
</div>
